import { encodeNestedObject } from '../../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const deleteTeachingHallComment = (data: { teachingHallId: number; ids: number[] }) => {
  const { teachingHallId, ids } = data
  return restApiClient
    .url(
      encodeNestedObject(
        constructApiUrl(API.teachingHallComments.delete.url, { teachingHallId }),
        { ids }
      )
    )
    .delete()
}
